import "regenerator-runtime/runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import App from "./App";
import theme from "./theme";
import "./styles.css";
import { msalConfig } from "./AuthConfig";
import { Provider } from "react-redux";
import store from "./store";
import { AuthProvider } from "./context/AuthContext";
import { setMsalInstance } from "./api/AxiosClient";

// ✅ Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  // Set MSAL instance for AxiosClient to use
  setMsalInstance(msalInstance);

  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <MsalProvider instance={msalInstance}>
              <AuthProvider>
                <App />
              </AuthProvider>
            </MsalProvider>
          </BrowserRouter>
        </Provider>
      </ThemeProvider>
    </React.StrictMode>
  );
});
